export class XUser {
code: string = '';
name: string = '';
section: string = '';
sexe:number = 0;
  public constructor() {
  }
}
